export const FETCH_CLIENT = 'FETCH_CLIENT';
export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_CONDITIONS_SURVEYS = 'FETCH_CONDITIONS_SURVEYS';
export const FETCH_ORGANIZATION = 'FETCH_ORGANIZATION';
export const FETCH_CLIENT_ORGANIZATION = 'FETCH_CLIENT_ORGANIZATION';
export const FETCH_ORGANIZATIONS = 'FETCH_ORGANIZATIONS';
export const FETCH_USER_INVITATIONS = 'FETCH_USER_INVITATIONS';

/**SCHEDULER */
export const FETCH_SCHEDULERS = 'FETCH_SCHEDULERS';
export const FETCH_SCHEDULER = 'FETCH_SCHEDULER';
export const ADD_EMPTY_SCHEDULER_MESSAGE = 'ADD_EMPTY_SCHEDULER_MESSAGE';
export const REMOVE_SCHEDULER_MESSAGE = 'REMOVE_SCHEDULER_MESSAGE';
export const CLEAN_SCHEDULERS = 'CLEAN_SCHEDULERS';
export const SET_SCHEDULER_MESSAGE = 'SET_SCHEDULER_MESSAGE';
export const UPDATE_SCHEDULER_MESSAGE = 'UPDATE_SCHEDULER_MESSAGE';
export const FETCH_SCHEDULERS_CHANNEL = 'FETCH_SCHEDULERS_CHANNEL';
